






























































import { defineComponent, ref } from '@vue/composition-api';
import ViBoxsAutoHeight from '../box-auto-height/index.vue';

const name = 'ttam-target-summary-item';
export default defineComponent({
  name,
  components: {
    ViBoxsAutoHeight,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const toggleStatue = ref(false);
    const isNotEmpty = item => item.data?.length || item.children?.some(child => child.data?.length > 0);

    return {
      name,
      toggleStatue,
      isNotEmpty,
    };
  },
});
